// Yii возвращает поле как массив или как строку — нормализуем в массив.
export function normalizeErrors(raw: unknown): Record<string, string[]> {
  if (!raw || typeof raw !== 'object') return {};
  const out: Record<string, string[]> = {};
  for (const [k, v] of Object.entries(raw as Record<string, unknown>)) {
    if (Array.isArray(v)) {
      out[k] = v.map(String);
    } else if (typeof v === 'string') {
      out[k] = [v];
    } else if (v != null) {
      out[k] = [String(v)];
    }
  }
  return out;
}
